module.exports = __webpack_public_path__ + "img/bill_today.fda8e224.png";